import React from 'react';

const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.715 17.5a1.36 1.36 0 01-.993-.433l-3.854-4.131a1.374 1.374 0 01.062-1.934 1.356 1.356 0 011.924.063l2.767 2.965 5.444-7.004a1.355 1.355 0 011.91-.235c.595.465.7 1.325.236 1.92l-6.423 8.262a1.354 1.354 0 01-1.011.525l-.062.002",
  fillRule: "evenodd"
}));

export default SvgCheckmark;